// Utility function to properly capitalize platform names
export const capitalizePlatformName = (platformName) => {
    if (!platformName || typeof platformName !== 'string') {
        return platformName;
    }

    // Handle common platform name mappings
    const platformMappings = {
        'google': 'Google',
        'facebook': 'Facebook',
        'yelp': 'Yelp',
        'tripadvisor': 'TripAdvisor',
        'airbnb': 'Airbnb',
        'booking': 'Booking.com',
        'amazon': 'Amazon',
        'apple-app-store': 'Apple App Store',
        'appstore': 'App Store',
        'google-play': 'Google Play',
        'googleplay': 'Google Play',
        'bbb': 'BBB',
        'capterra': 'Capterra',
        'dealerrater': 'DealerRater',
        'dealer-rater': 'DealerRater',
        'ebay': 'eBay',
        'edmunds': 'Edmunds',
        'g2': 'G2',
        'hotels': 'Hotels.com',
        'houzz': 'Houzz',
        'linkedin': 'LinkedIn',
        'opentable': 'OpenTable',
        'trustpilot': 'Trustpilot',
        'sitejabber': 'Sitejabber',
        'foursquare': 'Foursquare',
        'glassdoor': 'Glassdoor',
        'indeed': 'Indeed',
        'zillow': 'Zillow',
        'healthgrades': 'Healthgrades',
        'vitals': 'Vitals',
        'zocdoc': 'ZocDoc',
        'grubhub': 'Grubhub',
        'doordash': 'DoorDash',
        'instagram': 'Instagram',
        'twitter': 'Twitter',
        'pinterest': 'Pinterest',
        'youtube': 'YouTube',
        'tiktok': 'TikTok',
        'snapchat': 'Snapchat',
        'whatsapp': 'WhatsApp',
        'telegram': 'Telegram'
    };

    // Normalize the input - remove spaces, convert to lowercase
    const normalizedName = platformName.toLowerCase().trim();

    // Check if we have a specific mapping
    if (platformMappings[normalizedName]) {
        return platformMappings[normalizedName];
    }

    // Handle "Reviews" suffix removal and capitalization
    let cleanName = platformName;

    // Remove " Reviews" or " reviews" suffix if present
    cleanName = cleanName.replace(/ [Rr]eviews?$/g, '');

    // Capitalize first letter of each word
    return cleanName
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
};

// Helper function specifically for display purposes - removes "Reviews" and capitalizes
export const formatPlatformNameForDisplay = (platformName) => {
    const capitalized = capitalizePlatformName(platformName);
    // Remove "Reviews" suffix for display
    return capitalized.replace(/ Reviews?$/g, '');
};
